// LUMINA · pages/vajra/admin/ServiceRequestsSection.jsx
// Phase 112: Admin management for dharma service requests

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, DG, CR, TXT, TXT2, PANEL } from '../constants';

const STATUS_LABELS = {pending:"待处理",assigned:"已分配",in_progress:"处理中",accepted:"已受理",completed:"已完成",cancelled:"已取消",declined:"已婉拒"};
const STATUS_COLORS = {pending:"#d97706",assigned:"#2563eb",in_progress:"#7c3aed",accepted:"#0891b2",completed:"#059669",cancelled:"#9ca3af",declined:"#9ca3af"};
const CAT_LABELS = {divination:"占卜",guidance:"开示",ritual:"修法",object:"法物"};

export default function ServiceRequestsSection({ token, headers }) {
  const [requests, setRequests] = useState([]);
  const [types, setTypes]       = useState([]);
  const [teachers, setTeachers] = useState([]);
  useEffect(()=>{
    fetch(`${API}/vajra/teachers`)
      .then(r=>r.ok?r.json():[]).then(d=>setTeachers(Array.isArray(d)?d:[])).catch(()=>{});
  }, []);
  const [statusFilter, setStatusFilter] = useState("");
  const [editId, setEditId]     = useState(null);
  const [editForm, setEditForm] = useState({status:"",admin_notes:""});
  const [msg, setMsg]           = useState("");
  const [tab, setTab]           = useState("requests"); // "requests" | "types"
  const [typeForm, setTypeForm] = useState({name_zh:"",name_en:"",category:"ritual",description_zh:"",suggested_offering:""});
  const [typeMsg, setTypeMsg]   = useState("");

  const load = useCallback(async () => {
    const url = statusFilter
      ? `${API}/vajra/staff/service-requests?status=${statusFilter}`
      : `${API}/vajra/staff/service-requests`;
    const d = await fetch(url, {headers}).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setRequests(Array.isArray(d)?d:[]);
  }, [token, statusFilter]);

  const loadTypes = useCallback(async () => {
    const d = await fetch(`${API}/vajra/service-types`).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setTypes(Array.isArray(d)?d:[]);
  }, []);

  useEffect(() => { load(); loadTypes(); }, [load, loadTypes]);

  const saveRequest = async () => {
    const r = await fetch(`${API}/vajra/staff/service-requests/${editId}`, {
      method:"PUT", headers, body:JSON.stringify(editForm),
    });
    if (r.ok) { setMsg("✓ 已更新"); setEditId(null); load(); }
    else setMsg("✗ 更新失败");
  };

  const createType = async () => {
    if (!typeForm.name_zh) { setTypeMsg("请填写中文名称"); return; }
    const r = await fetch(`${API}/vajra/staff/service-types`, {
      method:"POST", headers,
      body:JSON.stringify({...typeForm, suggested_offering: typeForm.suggested_offering ? parseFloat(typeForm.suggested_offering) : null, sort_order:0}),
    });
    if (r.ok) { setTypeMsg("✓ 已创建"); setTypeForm({name_zh:"",name_en:"",category:"ritual",description_zh:"",suggested_offering:""}); loadTypes(); }
    else setTypeMsg("✗ 创建失败");
  };

  const deleteType = async (id) => {
    if (!window.confirm("确认停用该服务类型？")) return;
    await fetch(`${API}/vajra/staff/service-types/${id}`, {method:"DELETE", headers});
    loadTypes();
  };

  const inputStyle = {width:"100%",padding:"7px 10px",borderRadius:7,border:"1px solid rgba(212,175,55,0.35)",background:"#fff",color:TXT,fontSize:13,outline:"none",boxSizing:"border-box"};

  return (
    <div>
      {/* Tab switcher */}
      <div style={{display:"flex",gap:0,marginBottom:20,borderBottom:"1px solid rgba(212,175,55,0.2)"}}>
        {[{k:"requests",l:"祈请记录"},{k:"types",l:"服务类型"}].map(t=>(
          <button key={t.k} onClick={()=>setTab(t.k)} style={{
            padding:"8px 20px",fontSize:12,cursor:"pointer",background:"transparent",border:"none",
            borderBottom:`2px solid ${tab===t.k?GD:"transparent"}`,color:tab===t.k?GD:TXT2,transition:"all .15s",letterSpacing:.5,
          }}>{t.l}</button>
        ))}
      </div>

      {tab === "requests" && (
        <div>
          {/* Filter row */}
          <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
            {["","pending","assigned","in_progress","accepted","completed","cancelled","declined"].map(s=>(
              <button key={s} onClick={()=>setStatusFilter(s)} style={{
                fontSize:11,padding:"4px 12px",borderRadius:20,cursor:"pointer",
                background:statusFilter===s?GD:"transparent",color:statusFilter===s?"#fff":TXT2,
                border:`1px solid ${statusFilter===s?GD:"rgba(0,0,0,0.15)"}`,
              }}>{s?STATUS_LABELS[s]:"全部"}</button>
            ))}
          </div>

          {msg&&<div style={{fontSize:12,padding:"7px 10px",borderRadius:6,marginBottom:10,
            background:msg.startsWith("✓")?"rgba(6,78,59,0.07)":"rgba(107,26,26,0.07)",
            color:msg.startsWith("✓")?DG:CR}}>{msg}</div>}

          {requests.length===0&&<div style={{textAlign:"center",padding:"30px",color:"#ccc",fontSize:13}}>暂无祈请记录</div>}

          {requests.map(req=>(
            <div key={req.id} style={{borderRadius:10,border:"1px solid rgba(0,0,0,0.07)",padding:"14px 16px",marginBottom:10,background:PANEL}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div>
                  <span style={{fontSize:12,fontWeight:600,color:TXT}}>{req.requester_name||"匿名"}</span>
                  {req.requester_email&&<span style={{fontSize:11,color:"#aaa",marginLeft:8}}>{req.requester_email}</span>}
                  {req.service_type&&<span style={{fontSize:10,padding:"1px 8px",borderRadius:8,background:"rgba(212,175,55,0.08)",color:GD,border:"1px solid rgba(212,175,55,0.2)",marginLeft:8}}>{req.service_type}</span>}
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:10,padding:"2px 10px",borderRadius:10,
                    background:`${STATUS_COLORS[req.status]||"#999"}15`,color:STATUS_COLORS[req.status]||"#999",
                    border:`1px solid ${STATUS_COLORS[req.status]||"#999"}33`}}>
                    {STATUS_LABELS[req.status]||req.status}
                  </span>
                  {req.teacher_id && teachers.find(t=>String(t.id)===String(req.teacher_id)) && (
                    <span style={{fontSize:11,color:"#6b7280",marginLeft:8}}>
                      → {teachers.find(t=>String(t.id)===String(req.teacher_id))?.name_zh}
                    </span>
                  )}
                  <button onClick={()=>{setEditId(req.id);setEditForm({status:req.status,admin_notes:req.admin_notes||"",teacher_id:req.teacher_id||""});setMsg("");}} style={{
                    fontSize:10,padding:"2px 10px",borderRadius:6,cursor:"pointer",
                    background:"rgba(212,175,55,0.06)",color:GD,border:`1px solid rgba(212,175,55,0.25)`}}>
                    处理
                  </button>
                </div>
              </div>
              {req.description&&<div style={{fontSize:12,color:TXT2,lineHeight:1.5,marginBottom:6}}>{req.description}</div>}
              <div style={{fontSize:10,color:"#bbb"}}>{req.created_at?.slice(0,10)}{req.offering_amount?` · 供养 $${req.offering_amount}`:""}</div>
              {req.admin_notes&&<div style={{fontSize:11,color:"#64748b",marginTop:6,padding:"5px 8px",background:"rgba(0,0,0,0.02)",borderRadius:5}}>📝 {req.admin_notes}</div>}

              {editId===req.id&&(
                <div style={{marginTop:12,padding:12,background:"rgba(212,175,55,0.04)",borderRadius:8,border:"1px solid rgba(212,175,55,0.15)"}}>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10,marginBottom:10}}>
                    <div>
                      <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>状态</label>
                      <select value={editForm.status} onChange={e=>setEditForm(p=>({...p,status:e.target.value}))} style={inputStyle}>
                        {Object.entries(STATUS_LABELS).map(([k,v])=><option key={k} value={k}>{v}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>内部备注</label>
                      <input value={editForm.admin_notes} onChange={e=>setEditForm(p=>({...p,admin_notes:e.target.value}))} style={inputStyle} placeholder="内部处理备注"/>
                    </div>
                  </div>
                  {teachers.length > 0 && (
                    <div style={{marginTop:12}}>
                      <label style={{fontSize:11,color:"#aaa",marginBottom:3,display:"block"}}>指派上师 / Assign Teacher</label>
                      <select
                        value={editForm.teacher_id || ""}
                        onChange={e=>setEditForm(p=>({...p,teacher_id:e.target.value||null}))}
                        style={inputStyle}
                      >
                        <option value="">— 未指派 —</option>
                        {teachers.map(t=>(
                          <option key={t.id} value={t.id}>{t.name_zh}{t.name_en?` / ${t.name_en}`:""}</option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={saveRequest} style={{fontSize:11,padding:"5px 16px",borderRadius:7,cursor:"pointer",background:`linear-gradient(135deg,${GD},#A07828)`,border:"none",color:"#fff"}}>保存</button>
                    <button onClick={()=>setEditId(null)} style={{fontSize:11,padding:"5px 12px",borderRadius:7,cursor:"pointer",background:"transparent",color:"#999",border:"1px solid #e5e7eb"}}>取消</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {tab === "types" && (
        <div>
          {typeMsg&&<div style={{fontSize:12,padding:"7px 10px",borderRadius:6,marginBottom:10,
            background:typeMsg.startsWith("✓")?"rgba(6,78,59,0.07)":"rgba(107,26,26,0.07)",
            color:typeMsg.startsWith("✓")?DG:CR}}>{typeMsg}</div>}

          {/* Create form */}
          <div style={{background:"rgba(212,175,55,0.04)",borderRadius:10,padding:16,marginBottom:20,border:"1px solid rgba(212,175,55,0.15)"}}>
            <div style={{fontSize:12,color:GD,fontWeight:600,marginBottom:12}}>添加服务类型</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:10}}>
              <div>
                <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>中文名称 *</label>
                <input value={typeForm.name_zh} onChange={e=>setTypeForm(p=>({...p,name_zh:e.target.value}))} style={inputStyle} placeholder="如: 消灾超度法会"/>
              </div>
              <div>
                <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>英文名称</label>
                <input value={typeForm.name_en} onChange={e=>setTypeForm(p=>({...p,name_en:e.target.value}))} style={inputStyle} placeholder="e.g. Merit Puja"/>
              </div>
              <div>
                <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>类别</label>
                <select value={typeForm.category} onChange={e=>setTypeForm(p=>({...p,category:e.target.value}))} style={inputStyle}>
                  {Object.entries(CAT_LABELS).map(([k,v])=><option key={k} value={k}>{v}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:10,marginBottom:10}}>
              <div>
                <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>描述</label>
                <input value={typeForm.description_zh} onChange={e=>setTypeForm(p=>({...p,description_zh:e.target.value}))} style={inputStyle} placeholder="简短描述"/>
              </div>
              <div>
                <label style={{fontSize:11,color:TXT2,marginBottom:3,display:"block"}}>建议供养 ($)</label>
                <input type="number" value={typeForm.suggested_offering} onChange={e=>setTypeForm(p=>({...p,suggested_offering:e.target.value}))} style={inputStyle} placeholder="0"/>
              </div>
            </div>
            <button onClick={createType} style={{fontSize:12,padding:"7px 20px",borderRadius:7,cursor:"pointer",background:`linear-gradient(135deg,${GD},#A07828)`,border:"none",color:"#fff"}}>创建</button>
          </div>

          {/* Types list */}
          {types.map(t=>(
            <div key={t.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",borderRadius:8,border:"1px solid rgba(0,0,0,0.07)",marginBottom:8,background:PANEL}}>
              <div>
                <span style={{fontSize:13,fontWeight:500,color:TXT}}>{t.name_zh}</span>
                {t.name_en&&<span style={{fontSize:11,color:"#aaa",marginLeft:8}}>{t.name_en}</span>}
                <span style={{fontSize:10,padding:"1px 8px",borderRadius:8,background:"rgba(0,0,0,0.05)",color:TXT2,border:"1px solid rgba(0,0,0,0.1)",marginLeft:8}}>{CAT_LABELS[t.category]||t.category}</span>
                {t.suggested_offering&&<span style={{fontSize:10,color:GD,marginLeft:8}}>¥{t.suggested_offering}</span>}
              </div>
              <button onClick={()=>deleteType(t.id)} style={{fontSize:10,padding:"2px 8px",borderRadius:5,cursor:"pointer",background:"transparent",color:"#e57373",border:"1px solid rgba(231,74,74,0.2)"}}>停用</button>
            </div>
          ))}
          {types.length===0&&<div style={{textAlign:"center",padding:"20px",color:"#ccc",fontSize:13}}>暂无服务类型 · 请添加</div>}
        </div>
      )}
    </div>
  );
}
